var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-loader', { '--white': _vm.white, '--thin': _vm.thin }]})}
var staticRenderFns = []

export { render, staticRenderFns }